import escapeRegExp from 'escape-string-regexp';

/**
 * Check for subset array
 *
 * @param {[]} main: Array of elements
 * @param {[]} subarray: Array of elements
 * @returns {boolean} True if each element of subarray is in main
 */
export const hasSubArray = (main, subarray) => subarray.every(v => main.includes(v));

export const isSubstring = (haystack, needle) => {
  const searchPattern = new RegExp(escapeRegExp(needle), 'i');
  if (Array.isArray(haystack)) {
    const mappedHaystacks = haystack.filter(currentStack => currentStack.match(searchPattern));
    return mappedHaystacks.length > 0;
  }

  return haystack?.match(searchPattern);
};
